import React from 'react';

import Base from './Base.jsx';

import ArticleBookmarkSinglePost from '../Components/ArticleBookmarkSinglePost/index.jsx';



class EntryPoint extends Base {
  id() {
    return 'cs-article-bookmark';
  }

  renderElement(element) {
    var slug = element.dataset.slug;
    return (

      <ArticleBookmarkSinglePost postSlug={slug} />
    );
  }
}


export default EntryPoint;

